export function isUserOpResponse(tx) {
    return typeof tx === 'object' && tx !== null && 'userOpHash' in tx && 'wait' in tx;
}
